type Nickname = {
  address: string;
  nickname: string;
};

const getNicknames = async (): Promise<Nickname[]> => {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/nickname`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });
  if (!response.ok) {
    throw new Error("Error fetching wallet activity stats");
  }

  const data = (await response.json()) as Nickname[];

  return data;
};

const setNickname = async (
  senderAddress: string,
  address: string,
  nickname: string,
  signature: string,
) => {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/nickname`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ senderAddress, address, nickname, signature }),
  });
  if (!response.ok) {
    throw new Error("Error setting nickname");
  }

  const data = (await response.json()) as Nickname;

  return data;
};

const deleteNickname = async (
  senderAddress: string,
  address: string,
  signature: string,
) => {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/nickname`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ senderAddress, address, signature }),
  });
  if (!response.ok) {
    throw new Error("Error deleting nickname");
  }

  return;
};

export { getNicknames, setNickname, deleteNickname };
export type { Nickname };
